import React from 'react';
import AG_ALERT from './Content/AG_ALERT/content.js';
import VIDEO from './Content/VIDEO/content.js';
import ARTICLE from './Content/ARTICLE/content.js';
import NEWSLETTER from './Content/NEWSLETTER/content.js';
import PRODUCT_GUIDE from './Content/PRODUCT_GUIDE/content.js';
import LINK from './Content/LINK/content.js';
import content_styles from './PageContent.module.css';

const content={
	AG_ALERT:AG_ALERT,
	VIDEO:VIDEO,
	ARTICLE:ARTICLE,
	NEWSLETTER:NEWSLETTER,
	PRODUCT_GUIDE:PRODUCT_GUIDE,
	WEBINAR:VIDEO,
	LINK:LINK
}

const PageContent=(props)=>{
	if(props.data.Content_Type && content[props.data.Content_Type]){
		let Content=content[props.data.Content_Type];
		return (
			<Content {...props}
				content_styles={content_styles}
			/>
		);
	}

	return (<div>UNSUPPORT CONTENT TYPE</div>);
}

export default PageContent;